import * as filesize from 'filesize'

import { File } from '../interfaces/File.interface'
import { Name } from '../interfaces/Name.interface'
import { Location } from '../interfaces/Location.interface'

import { Duration } from 'moment'

const compact = require('lodash/compact')
const indexOf = require('lodash/indexOf')

export function formatName(name?: Name): string|undefined {
  if (!name) { return undefined }
  return compact([name.firstName, name.lastName]).join(' ')
}

export function formatLocation(location: Location): string {
  return `${location.name}, ${location.state}`
}

export function formatFileSize(size: number) {
  return filesize(size)
}

export function formatFileName(file?: File) {
  if (file && file.key) {
    const dashIndex = indexOf(file.key, '/')

    if (dashIndex >= 0) {
      return file.key.substring(dashIndex + 1)
    }
  }

  return file && file.key
}

export function formatAddress(state, city, street) {
  return compact([street, city, state]).join(', ')
}

export function formatMomentDuration(duration?: Duration) {
  if (duration) {
    const hours = _formatOrZero(duration.hours())
    const minutes = _formatOrZero(duration.minutes())
    const seconds = _formatOrZero(duration.seconds())

    return hours !== '00'
      ? `${hours}:${minutes}:${seconds}`
      : `${minutes}:${seconds}`
  }

  return null
}

function _formatOrZero(value) {
	if (value) {
		return value > 9 ? `${value}` : `0${value}`
	}

	return '00'
}



// WEBPACK FOOTER //
// ./src/lib/helpers/format.ts